import apiService from "./apiService";

const sellerService = {
    updateSellerProfile: async (sellerName: string, sellerDescription: string) => {
        return await apiService.put(`/seller/Profile`, { sellerName: sellerName, sellerDescription: sellerDescription });
    },
    updateSellerAddress: async (addressLine1: string, addressLine2: string, city: string, state: string, postcode: string, country: string) => {
        return await apiService.put(`/seller/Address`, { addressLine1: addressLine1, addressLine2: addressLine2, city: city, state: state, postcode: postcode, country: country });
    },
    updateSellerBusinessAndContactDetails: async (businessName: string, email: string, contactNumber: string, countryCode:string) => {
        return await apiService.put(`/Seller/BusinessAndContactDetails`, { businessName: businessName, email: email, contactNumber: contactNumber, countryCode:countryCode });
    },
    updateSellerPaymentMethods: async (paymentMethodIDs: number[], paymentTerms:string) => {
        return await apiService.put(`/seller/PaymentMethod`, { paymentMethodIDs: paymentMethodIDs, paymentTerms: paymentTerms});
    },
    updateSellerShippingPolicy: async (shippingPolicy: string) => {
        return await apiService.put(`/seller/ShippingPolicy`, { shippingPolicy: shippingPolicy });
    },
    updateSellerReturnPolicy: async (returnPolicy: string) => {
        return await apiService.put(`/seller/ReturnPolicy`, { returnPolicy: returnPolicy });
    }
};


export default sellerService;